import dropdownContentTemplate from './dropdown-content.html?raw';

export class DropdownContent extends HTMLElement {
    static get observedAttributes() {
        return ['open'];
    }

    constructor() {
        super();

        this.content = null;

        this.localization = {
            openMessage: 'Dropdown opened',
            closeMessage: 'Dropdown closed',
        };
    }

    connectedCallback() {
        this.attachShadow({ mode: 'open' });

        const template = document.createElement('template');
        template.innerHTML = dropdownContentTemplate;
        this.shadowRoot.appendChild(template.content.cloneNode(true));

        this.content = this.shadowRoot.querySelector('.dropdown-content');

        if (this.isOpen()) {
            this.content.classList.remove('hidden');
        } else {
            this.content.classList.add('hidden');
        }

        this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) {
                this.emit('closed');
                this.close();
            }
        });
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) {
            return;
        }

        switch (name) {
            case 'open':
                if (!this.content) return;

                if (newValue !== 'false' && newValue !== null) {
                    this.content.classList.remove('hidden');
                } else {
                    if (!this.content.classList.contains('hidden'))
                        this.content.classList.add('hidden');
                }
                break;
        }
    }

    open() {
        this.setAttribute('open', '');
        this.updateLiveRegionMessage(this.localization.openMessage);
    }

    close() {
        this.removeAttribute('open');
        this.updateLiveRegionMessage(this.localization.closeMessage);
    }

    isOpen() {
        return (
            this.hasAttribute('open') && this.getAttribute('open') !== 'false'
        );
    }

    setLocalization(localization) {
        this.localization = { ...this.localization, ...localization };
    }

    emit(eventName, detail = {}) {
        this.dispatchEvent(
            new CustomEvent(`dropdown:${eventName}`, {
                detail,
                bubbles: true,
                composed: true,
            })
        );
    }

    updateLiveRegionMessage(message) {
        const liveRegion = this.shadowRoot.querySelector(
            '.dropdown-content-live-region'
        );

        if (liveRegion) liveRegion.textContent = message;

        setTimeout(() => {
            liveRegion.textContent = '';
        }, 100);
    }
}

customElements.define('svea-dropdown-content', DropdownContent);
